'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _captcha = require('../actions/captcha');

var _register = require('../actions/register');

var _register_form = require('../components/register_form');

var _register_form2 = _interopRequireDefault(_register_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetPassword = _react2.default.createClass({
    displayName: 'ResetPassword',

    propTypes: {
        captcha: _react.PropTypes.object.isRequired,
        register: _react.PropTypes.object.isRequired,
        dispatch: _react.PropTypes.func.isRequired
    },
    onSubmit: function onSubmit(profile) {
        this.props.dispatch((0, _register.requestRegisterIfNeeded)(_extends({}, profile, {
            type: 'reset'
        })));
    },
    onGetCaptcha: function onGetCaptcha(mobile) {
        this.props.dispatch((0, _captcha.requestCaptchaIfNeeded)(mobile));
    },
    render: function render() {
        return _react2.default.createElement(
            'div',
            { id: 'reset-password' },
            _react2.default.createElement(_register_form2.default, { submitText: '\u786E\u8BA4\u4FEE\u6539', onGetCaptcha: this.onGetCaptcha, captcha: this.props.captcha, onSubmit: this.onSubmit })
        );
    }
});

var mapStateToProps = function mapStateToProps(store) {
    var captcha = store.captcha,
        register = store.register;

    return {
        captcha: captcha, register: register
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ResetPassword);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/reset_password.js
// module id = 1565
// module chunks = 0